import {css} from 'lit'; export default css`.verification-checker{display:flex;flex-direction:column;align-items:center}`;
    